module.exports = __webpack_public_path__ + "static/media/golden_treasures.8df77379.png";